<template>
  <div id="app">
    <VerbPractice />
  </div>
</template>

<script>
import VerbPractice from "./components/VerbPractice.vue";

export default {
  name: "App",
  components: {
    VerbPractice,
  },
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
}
</style>
